import { Injectable } from '@angular/core';
import {HttpService} from "./http.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {Contradiction} from "../models/contradiction.model";

@Injectable({
  providedIn: 'root'
})
export class ContradictionService {

  constructor(private httpService: HttpService) { }

  getContradiction(userId: number): Observable<Contradiction>{
    return this.httpService.request('get',`/v1/admin/user/contradiction?user_id=${userId}`).pipe(
      map((response: any) => response.data),
    );
  }
}
